import Avatar from './components';

export default Avatar;



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js